import { createStore } from 'vuex'

export default createStore({
  state: {
    carrinho: []
  },
  getters: {
    getCarrinho: state => state.carrinho
  },
  mutations: {
    setCarrinho (state, payload) {
      state.carrinho = payload
    }
  },
  actions: {
  },
  modules: {
  }
})
